import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getQuotationExtrasThunk, getQuotationThunk, quotationsSelector } from "../../features/quotationsSlice";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { getUserInfoThunk, userSliceSelector } from "../../features/userSlice";
import { useEffect } from "react";
import { QuotationDetails } from "./QuotationDetails";
import { OrderSummary } from "./OrderSummary";
import { Extras } from "./Extras";
import { QuotationActionsAndPrice } from "./QuotationActionsAndPrice";
import { QuotationStatus } from "../../constants/QuotationConstants";
import { QuotationDetailsLoading } from "./QuotationDetailsLoading";
import { OrderSummaryLoading } from "./OrderSummaryLoading";
import { ExtrasLoading } from "./ExtrasLoading";
import { QuotationOrderedBanner } from "./QuotationOrderedBanner";

export const QuotationDetailsPage = () => {
    const { quotationId } = useParams();
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);
    const { UserInfoStatus } = useAppSelector(userSliceSelector);
    const {
        SelectedQuotationStatus,
        SelectedQuotation,
        SelectedQuotationExtrasStatus
    } = useAppSelector(quotationsSelector);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (user && UserInfoStatus === "idle") {
            dispatch(getUserInfoThunk({userId: user.username!}));
        }
    }, [user]);

    useEffect(() => {
        if (UserInfoStatus === "succeeded" && quotationId) {
            dispatch(getQuotationThunk({quotationId: quotationId, user: user}));
            dispatch(getQuotationExtrasThunk({quotationId: quotationId, user: user}));
        }
    }, [UserInfoStatus]);

    if (SelectedQuotationStatus === "failed") {
        navigate("/error/404");
    }

    return (
        <div>
            {SelectedQuotationStatus === "succeeded" && SelectedQuotation?.status === QuotationStatus.ORDERED && (
                <QuotationOrderedBanner />
            )}
            <div
            id="quotation-details-page"
            data-cy="quotation-details-page"
            className="col-12 flex lg:flex-row flex-column"
            >
                <div
                    className="lg:col-4 col-12"
                    id="quotation-details-lhs"
                    data-cy="quotation-details-lhs"
                >
                    {SelectedQuotationStatus === "succeeded" ? (
                        <QuotationDetails />
                    ) : (
                        <QuotationDetailsLoading />
                    )}
                </div>
                <div
                    className="lg:col-8 col-12 flex flex-column"
                >
                    {SelectedQuotationStatus === "succeeded" ? (
                        <OrderSummary />
                    ) : (
                        <OrderSummaryLoading />
                    )}
                    <div className="mt-3">
                        {SelectedQuotationStatus === "succeeded" && SelectedQuotationExtrasStatus === "succeeded" && SelectedQuotation ? (
                        <Extras />
                        ) : (
                            <ExtrasLoading />
                        )}
                        <QuotationActionsAndPrice />
                    </div>
                </div>
            </div>
        </div>
    )
}